import React from 'react'

import footerLayoutConfig from '../../../../config/layout/footer'
import FooterMarketplaceStats from './marketplaceStats'
import UsDollarsNoticeContainer from '../usDollarsNotice/usDollarsNoticeContainer'
import { config } from '../../../../common/config'
import ui from '../../../../common/constants/ui'
import TextLink from '../textLink'
import EnhancedLazyLoad from '../enhancedLazyLoad'

import styles from './siteFooter.module.css'

const SiteFooter = ({ stats, usDollarsNotice }) => {
  const { infoLinks, companyLinks, socialMediaLinks } = footerLayoutConfig
  const currentYear = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={styles.gridWide}>
        <div className={styles.container}>
          <nav className={styles.navContainer}>
            <hr className={styles.separatorTop} />

            <ul className={styles.listsContainer}>
              {infoLinks.map(column => {
                return (
                  <li key={column.key} className={styles.listsItem}>
                    <ul className={styles.sublistContainer}>
                      <li className={styles.sublistTitle}>
                        {column.titleHtml}
                      </li>
                      {column.entries.map(entry => {
                        return (
                          <li key={entry.key} className={styles.sublistItem}>
                            <TextLink
                              href={entry.url}
                              className={styles.textLink}
                            >
                              {entry.label}
                            </TextLink>
                          </li>
                        )
                      })}
                    </ul>
                  </li>
                )
              })}
            </ul>
          </nav>

          <div className={styles.statsContainer}>
            <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
              <img
                className={styles.logo}
                alt="Envato Market"
                src={`${
                  config.assets.PUBLIC_PATH
                }/images/logo-envato-market.svg`}
              />
            </EnhancedLazyLoad>
            <FooterMarketplaceStats stats={stats} />
          </div>
        </div>

        <hr className={styles.separator} />
        <div className={styles.container}>
          <div className={styles.companyLinksContainer}>
            <ul className={styles.companyLinksList}>
              {companyLinks.map(entry => {
                return (
                  <li key={entry.key} className={styles.listItem}>
                    <TextLink
                      href={entry.url}
                      className={styles.textLinkFullOpacity}
                    >
                      {entry.label}
                    </TextLink>
                  </li>
                )
              })}
            </ul>

            <hr className={styles.separatorBottom} />

            <UsDollarsNoticeContainer styleClassName={styles.copyrights} />

            <small className={styles.copyrights}>
              © {currentYear} Envato Pty Ltd. Trademarks and brands are the
              property of their respective owners.
            </small>
          </div>

          <div className={styles.socialContainer}>
            <ul itemScope itemType="http://schema.org/Organization">
              {socialMediaLinks.map(entry => {
                const iconSrc = config.assets.PUBLIC_PATH + entry.icon
                return (
                  <li key={entry.key} className={styles.socialItem}>
                    <a
                      className={styles.iconLink}
                      rel="nofollow"
                      href={entry.url}
                      aria-label={entry.label}
                    >
                      <EnhancedLazyLoad
                        height="100%"
                        once
                        offset={ui.lazyLoadOffset}
                      >
                        <img
                          className={styles.socialIcon}
                          alt={entry.label}
                          title={entry.label}
                          src={iconSrc}
                        />
                      </EnhancedLazyLoad>
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default SiteFooter
